"use strict";
var TriggerType;
(function (TriggerType) {
    TriggerType[TriggerType["CLICK"] = 0] = "CLICK";
    TriggerType[TriggerType["BLUR"] = 1] = "BLUR";
    TriggerType[TriggerType["FOCUS"] = 2] = "FOCUS";
    TriggerType[TriggerType["HOVER"] = 3] = "HOVER";
    TriggerType[TriggerType["MANUAL"] = 4] = "MANUAL";
    TriggerType[TriggerType["MOUSEOUT"] = 5] = "MOUSEOUT";
})(TriggerType || (TriggerType = {}));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TriggerType;
